<template>
  <div>
    <aro-main-banner v-if="isNuskinChannel"/>

    <div v-bind:class="[{rew19_aro_wrap : isNuskinChannel}, {shop : isNuskinChannel}]">
      <div class="rew19_sticky" v-if="isNuskinChannel">
        <div class="rew19_tabContainer">
          <ul class="rew19_tab rew19_fxBetween">
            <!--rew19_active 현재 보여주는 페이지 (모바일 메뉴 슬라이드를 위함)-->

            <li v-for="(category, idx) in category_list"
                v-bind:key="idx"
                :class="{rew19_active : category.division_code == 'aroOnly'}"
                class="rew19_tab__button">
              <!--rew19_active-->
              <router-link :to="category.url"
                           class="rew19_coll">{{category.division_name_kr}}</router-link>
            </li>
          </ul>
        </div>
        <!--rew19_tabContainer-->

      </div>
      <!--//rew19_sticky-->

      <div class="rew19_goodsList_wrap">

        <!-- 뉴스킨 채널 경우-->
        <product-list-banner-aro-only v-if="isNuskinChannel"/>
        <!--//뉴스킨 채널 경우-->

        <div v-if="isNuskinChannel" class="rew18_tabSub_pc">
          <div class="rew18_arraySub_wrap rew18_clear">
            <ul class="rew18_arraySub rew18_clear">
              <li>
                <select v-model="listSortType" @change="sortProductList()" class="rew18_select_t1">
                  <option value="DEFAULT">기본 정렬</option>
                  <option value="PRICELOW">&nbsp;가격 낮은순&nbsp;</option>
                  <option value="PRICEHIGH">&nbsp;가격 높은순&nbsp;</option>
                  <option value="SVLOW">&nbsp;SV 낮은순&nbsp;</option>
                  <option value="SVHIGH">&nbsp;SV 높은순&nbsp;</option>
                </select>
              </li>
              <li>
                <select v-model="languageType" class="rew18_select_t1 langC">
                  <option value="KR">한국어</option>
                  <option value="EN">English</option>
                </select>
              </li>
            </ul>
          </div>
        </div>

        <!--미커머스 채널 경우-->
        <h3 v-if="isMeCommerceChannel">
          <p>정기구매 특별제품</p>
          <p><span></span></p>
        </h3>
        <!--//미커머스 채널 경우-->

        <div v-if="!productList || productList.length <= 0"
             class="rew19_noData_wrap noIcon">
          <span class="rew19_noData">검색 결과가 없습니다.</span>
        </div>

        <ul class="rew19_goodsList rew19_clear">
          <li v-for="(product, idx) in productList" v-bind:key="idx">
            <a class="rew19_aProduct"
               @click="onClickMoveProductDetail(product, idx)">
              <div class="rew19_goodsWrap">
                <div class="rew19_goodsImg">
                  <span class="rew18_goodsDim" v-if="product.isSoldOut == 'Y'">
									  <em>일시품절</em>
									</span>
                  <i v-if="product.isRetention == 'Y'"
                     class="rew19_goodsFlag fourplus">4+1</i>
                  <span class="rew19_rateImg">
                    <img
                      :src="product.pd_img_url1"
                      :alt="product.pd_id"
                      onError="imageError(this)" data-error-cnt="0"
                    />
                  </span>
                </div>
                <button type="button" @click.stop.prevent="onClickAddCart(product, product.division_code)" class="rew19_btn_putB">
                  <span class="rew19_icon_busk">장바구니 담기</span>
                </button>
              </div>
              <div v-show="languageType == 'KR'">
                <p class="rew19_goodsTxt">{{product.pd_name_kr}}</p>
                <p class="rew19_goodsPrice m">
                  <em class="rew19_gTit">정기구매가</em>
                  <span class="rew19_gDetail">
                    <strong>{{$fmt.WON(product.pd_amt1)}}</strong>원
                  </span>
                </p>
                <p class="rew19_goodsPrice p">
                  <em class="rew19_gTit">회원가</em>
                  <span class="rew19_gDetail">{{$fmt.WON(product.membersPrice)}}원</span>
                </p>
              </div>
              <div v-show="languageType == 'EN'">
                <p class="rew19_goodsTxt">{{product.pd_name_en}}</p>
                <p class="rew19_goodsPrice m">
                  <em class="rew19_gTit">ARO PRICE</em>
                  <span class="rew19_gDetail">
                    <strong>{{$fmt.WON(product.pd_amt1)}}</strong>
                  </span>
                </p>
                <p class="rew19_goodsPrice p">
                  <em class="rew19_gTit">PRICE</em>
                  <span class="rew19_gDetail">{{$fmt.WON(product.membersPrice)}}</span>
                </p>
              </div>
            </a>
          </li>
        </ul>

        <div class="rew19_basket_wrap">
          <div class="rew19_basket_center">
            <div class="rew19_basket_rate">
              <ul class="rew19_basket_detail">
                <li class="rew19_basket_su">
                  <em>수량</em>
                  <span class="rew19_point">{{$fmt.PDCnt(cartInfo["basketCount"])}}</span>
                  <span class="rew19_unit">개</span>
                </li>
                <li v-if="getMemberType() == 'DIST' || getMemberType() == 'PREF' || getMemberType() == 'GENERAL'"
                    class="rew19_basket_pv">
                  <em>SV</em>
                  <span class="rew19_money">{{$fmt.PV(cartInfo["total_pv"])}}</span>
                </li>
                <li class="rew19_basket_sum">
                  <span class="rew19_point">{{$fmt.WON(cartInfo["payment_amt"])}}</span>
                  <span class="rew19_unit">원</span>
                </li>
              </ul>
            </div>
            <a @click="onClickMoveBasket" class="rew19_basket_oder">
              <span>신규 정기구매 장바구니</span>
            </a>
          </div>
          <!--//rew19_basket_center-->
        </div>
        <!--//rew19_basket_wrap-->
      </div>
      <!--//rew19_goodsList_wrap-->
      <cart-added-popup :show="showCartAdded"></cart-added-popup>
      <cart-add-dialog
        ref="cartAddDialog"
        :show="cartAddDialogShow"
        :data='cartAddDialog'
        @close='onCloseCartAddDialog'></cart-add-dialog>
    </div>
    <!--rew19_aro_wrap-->
  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import CartAddedPopup from '@/components/popup/CartAdded';
import CartAddDialog from '@/components/popup/CartAddDialog';
import AroMainBanner from '@/components/banner/AroMainBanner';
import ProductListBannerAroOnly from '@/components/banner/ProductListBannerAroOnly';
import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";

export default {
  name: "ProductListAroOnly",
  extends: AroBase,
  components: { CartAddedPopup, CartAddDialog, AroMainBanner, ProductListBannerAroOnly },
  computed: {
    isNuskinChannel : function() {
      return this.$aroChannel == Const.ARO_CHANNEL_NUSKIN;
    },
    isMeCommerceChannel : function() {
      return this.$aroChannel == Const.ARO_CHANNEL_ME_COMMERCE;
    }
  },

  data: () => ({
    //View Data
    category_list: [],
    division_list: [],
    productList: [
      // {
      //   pd_id: "",
      //   pd_name_kr: "",
      //   pd_amt: "",
      //   pd_amt1: "",
      //   pd_img_url1: ""
      // }
    ],
    defaultProductList: [],

    params : {
      search_typ: "",
      search_key: ""
    },

    showCartAdded : false,
    cartInfo : {
      basketCount : 0,
      pd_count : 0,
      total_pv : "0.00",
      payment_amt : 0,
      uspan_pd_count : 0,
      uspan_total_pv : "0.00",
      uspan_payment_amt : 0,
    },
    cartAddDialogShow : false,
    cartAddDialog : {
      rawData : {
        countPerPage: 5,
        page: 1,
        totalCount: 0,
        //...
      },
      resData : {
        addTo : "CART", //장바구니:CART, aro_no:기존Aro에 추가
        aroData : null,
      }
    },

    gaTitle : "정기구매_특별제품",
    testText : "",

    listSortType : "DEFAULT",
    languageType : "KR",

    isRemove15per : "N",
    isAroOnlyCategory : "N"
  }),
  created() {
    let _this = this;

    if(_this.$aroChannel == Const.ARO_CHANNEL_NUSKIN){
      //Nuskin 경우 banner 표시

      let gFncShowBanner = function(){};
      if(typeof gVueInitVal_showProductBanner === "function"){
        console.debug(`Call gVueInitVal_showProductBanner function.`);
        gFncShowBanner = gVueInitVal_showProductBanner;
      }else{
        console.debug(`Undefined gVueInitVal_showProductBanner. Don't call..`);
      }
      gFncShowBanner.call();
    }
  },

  mounted() {
    let _this = this;

    _this.remove15perDate();

    _this.removeAroOnlyCategoryDate();

    _this.loadList();

    // 장바구니 정보 로드
    if(_this.isLogined()){
      _this.loadCartInfo();
    }

    //Aro UI
    _this.initUI();

  },

  methods: {
    /**
     * JQuery UI
     */
    initUI : function(){

    },

    /**
     * API Request
     */
    //카테고리 가져오기
    apiGetCategory : function(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/product/category`, {
        params: {}
      });
    },

    //상품목록 가져오기
    apiGetAroOnlyProductList : function() {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/product/aro_only_list`, {
        params: {
          search_typ: _this.params.search_typ,
          search_key: _this.params.search_key
        }
      });
    },

    //장바구니 정보 가져오기
    apiGetCart : function(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_cart`, {
        params: {}
      });
    },

    //장바구니에 상품 추가
    apiAddProductInCart : function(pd_id, pd_count, division_code){
      let _this = this;

      let pdAddList = [
        {
          pd_id : pd_id,
          pd_count : pd_count,
          division_code : division_code
        }
      ];

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/put_cart`, {
        params: {
          pd_add_list : JSON.stringify(pdAddList)
        },
        paramsSerializer: function (params) {
          return require('qs').stringify(params, {arrayFormat: 'brackets'})
        },
      });
    },

    //target 날짜 기준 15퍼 카테고리 제거
    apiRemove15perDate() {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/remove15perCategory`, {
        params: {}
      });
    },

    apiRemoveAroOnlyCategoryDate() {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/removeAroOnlyCategory`, {
        params: {}
      });
    },

    /**
     * Local function
     */

    //상품로드
    loadList : function() {
      let _this = this;

      //NetFunnel : '정기구매 SHOP' 대매뉴 또는 하위 브랜드 선택하여 제품 리스트 조회시
      NFStart({projectKey: 'service_1', segmentKey: 'act_11'}, function (response) {
        //show loading
        _this.$showLoading();
        _this.apiGetCategory().then(cateRes=>{
          if (cateRes.status === 200 && cateRes.data.status === "0000") {
            let list = cateRes.data.division_list;

            //Add additional info (url, etc...)
            list.forEach((item)=>{
              item.url = _this.$aroBasePath+`/list?division_code=${item.division_code}`;
            });
            _this.category_list = list;
          }

          { //Add static menu
            // if("Y" != _this.isRemove15per){
            //   _this.category_list.push({
            //     division_code : "15Per", division_name_kr : "정기구매 스페셜", division_name :"15% ARO",
            //     url : _this.$aroBasePath+"/list15Per"
            //   });
            // }

            if("Y" != _this.isAroOnlyCategory) {
              _this.category_list.push({
                division_code: "aroOnly", division_name_kr: "정기구매 특별제품", division_name: "Only Aro",
                url: _this.$aroBasePath + "/listAroOnly"
              });
            }

            _this.category_list.push({
              division_code : "ntc", division_name_kr : "NTC 정기기부", division_name :"NTC ARO",
              url : _this.$aroBasePath+"/listNtc"
            });

          }

          return _this.apiGetAroOnlyProductList();
        }).then(prodListRes=>{

          if (prodListRes.status === 200 && prodListRes.data.status === "0000") {
            _this.productList = [...prodListRes.data.pd_list];
            if(_this.isNuskinChannel){
              _this.defaultProductList = [...prodListRes.data.pd_list];
            }
          }

        }).catch(()=>{
          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
            .then(res => {});

        }).finally(()=>{
          NFStop();

          //hide loading
          _this.$hideLoading();

          //GA 전송-상품 목록
          try{
            _this.sendGaProductList();
          }catch(e){
            //ignore
            console.error(e);
          }
        });
      });
    },

    /**
     * 장바구니 관련
     */
    //장바구니 정보 로드
    loadCartInfo : function(){
      let _this = this;
      _this.$showLoading();
      _this.apiGetCart().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.cartInfo = {...res.data};
        }
      }).catch((err)=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    //장바구니 추가
    onClickAddCart : function(product, division_code){
      let _this = this;

      if(!_this.isLogined()){
        //비 로그인시
        _this.$openLoginConfirm();
        return;
      }

      if(product.isSoldOut == 'Y'){
        _this.$dialogs.alert('품절된 상품입니다.').then(res => {});
        return;
      }

      //GA 전송-장바구니 클릭
      try{
        _this.sendGaProductToCart(product, 1);
      }catch(e){
        //ignore
        console.error(e);
      }

      let pd_id = product.pd_id;
      let reqPageNo = 1;

      _this.$showLoading();
      _this.apiGetAro(reqPageNo).then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.cartAddDialog.rawData = res.data;

          if(!_this.cartAddDialog.rawData.totalCount || _this.cartAddDialog.rawData.totalCount <= 0){
            // ARO내역이 없으면, 바로 장바구니에 추가
            return _this.apiAddProductInCart(pd_id, 1, division_code);
          }

          //정기구매 선택 Dialog 표시
          _this.cartAddDialog.targetProduct = {
            pd_id : pd_id, division_code : division_code
          };
          _this.$refs.cartAddDialog.initData();
          _this.cartAddDialogShow = true;
        }else{
          //console.error(res);
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
            .then(res => {});
        }

        return null;
      }).then(res=>{
        if(res){
          if (res.status === 200 && res.data.status === "0000") {
            _this.showCartAdded = true;
            setTimeout(()=>{
              _this.showCartAdded = false;
            }, 1000);

            //장바구니 로드
            _this.loadCartInfo();

            //장바구니 변경 handler
            _this.$changeBasketCount();
          }else{
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
              .then(res => {});
          }
        }
      }).catch((err)=>{
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

      }).finally(()=>{
        _this.$hideLoading();
      });
    },

    //나의 ARO 정보 가져오기
    apiGetAro : function(pageNo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_aro`, {
        params: {
          isUspan : "N",
          page : pageNo,
          countPerPage : _this.cartAddDialog.rawData.countPerPage
        }
      });
    },

    //장바구니 다이얼로그 처리
    onCloseCartAddDialog(isOk, data) {
      let _this = this;
      _this.cartAddDialogShow = false;

      if(!isOk){
        //Do nothing.
        return;
      }

      //장바구니 직접등록 or 기존 aro 에 추가
      let retData = data;

      let pd_id = _this.cartAddDialog.targetProduct.pd_id;
      let division_code = _this.cartAddDialog.targetProduct.division_code;
      let pd_count = 1;
      let targetAro = retData.resData.aroData;

      if(retData.resData.addTo === "CART"){
        //장바구니에 추가
        _this.$showLoading();
        _this.apiAddProductInCart(pd_id, pd_count, division_code).then((res)=>{
          if (res.status === 200 && res.data.status === "0000"){
            //장바구니에 추가 popup
            _this.showCartAdded = true;
            setTimeout(()=>{
              _this.showCartAdded = false;
            }, 1000);

            //장바구니 로드
            _this.loadCartInfo();

            //장바구니 변경 handler
            _this.$changeBasketCount();
          }else{
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
              .then(res => {});
          }
        }).catch((err)=>{
          console.error(err);

          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
            .then(res => {});

        }).finally(()=>{
          _this.$hideLoading();
        });

      }else{
        //기존 ARO에 추가
        _this.$showLoading();
        _this.apiCheckAroModifyStatus(retData.resData.addTo).then((res)=>{
          if (res.status === 200 && res.data.status === "0000") {
            return _this.apiAddProductInAro(retData.resData.addTo, pd_id, pd_count);

          }else{
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
              .then(res => {});
            return null;
          }
        }).then((res)=>{
          if(res){
            if (res.status === 200 && res.data.status === "0000") {
              //기존 ARO에 추가 결과 msg
              let msg = '';
              msg += `정기구매 ${targetAro.aro_no}(${targetAro.subject})에 상품을 추가 하였습니다.<br/>`;
              msg += '동일한 상품이 있는 경우 자동으로 수량이 추가됩니다.<br/>';
              msg += '추가한 상품은 해당 정기결제일에 합산하여 배송됩니다.';

              _this.$dialogs.alert(msg).then(res => {});

            }else{
              //console.error(res);
              let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
              _this.$dialogs.alert(errMsg)
                .then(res => {});
            }
          }
        }).catch((err)=>{
          console.error(err);

          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
            .then(res => {});

        }).finally(()=>{
          _this.$hideLoading();
        });
      }
    },

    //장바구니 이동
    onClickMoveBasket(){
      let _this = this;

      if(!_this.isLogined()){
        //비 로그인시
        _this.$openLoginConfirm();
        return;
      }

      _this.$router.push(`${_this.$aroBasePath}/basket`);
    },

    //상품 클릭
    onClickMoveProductDetail(product, idx){
      let _this = this;

      //GA 전송-상품 목록
      try{
        _this.sendGaProductClick(product, idx, function(){
          _this.$router.push(`${_this.$aroBasePath}/detail/${product.pd_id}?pd_type=%ref_title=${_this.gaTitle}`);
        });
      }catch(e){
        //ignore
        console.error(e);
      }
    },

    //GA 전송-상품 목록
    sendGaProductList(){
      let _this = this;

      let gaData = {
        event: 'productList_ARO',
        product: []
      };

      gaData.product = _this.productList.map((prod, idx)=>{
        let retData = {
          name : prod.pd_name_kr,
          id : prod.pd_id,
          price : prod.pd_amt1,
          brand: prod.brandName ? prod.brandName : '',
          category: prod.categoryName ? prod.categoryName : '',
          variant : 'ARO',
          list : _this.gaTitle,
          position : (idx+1)
        };

        return retData;
      });

      _this.$sendAroGA(gaData);
    },

    //GA 전송-상품 클릭
    sendGaProductClick(prod, idx, callback){
      let _this = this;

      let gaData = {
        event: 'productClick_ARO',
        ecommerce: {
          click: {
            actionField: {
              list: _this.gaTitle
            },
            products : [
              {
                name : prod.pd_name_kr,
                id : prod.pd_id,
                price : prod.pd_amt1,
                brand: prod.brandName ? prod.brandName : '',
                category: prod.categoryName ? prod.categoryName : '',
                variant : 'ARO',
                position : (idx+1)
              },
            ]
          }
        }
      };

      _this.$sendAroGA(gaData, callback);
    },

    //GA 전송-장바구니 클릭
    sendGaProductToCart(prod, qty){
      let _this = this;

      let price = parseInt(""+prod.pd_amt1, 10);

      let gaData = {
        event: 'addToCart_ARO',
        ecommerce: {
          add: {
            currencyCode: 'KRW',
            products : [
              {
                name: prod.pd_name_kr,
                id: prod.pd_id,
                price: price,
                brand: prod.brandName ? prod.brandName : '',
                category: prod.categoryName ? prod.categoryName : '',
                variant : 'ARO',
                quantity: qty
              },
            ]
          }
        }
      };

      _this.$sendAroGA(gaData);
    },
    sortProductList(){
      let _this = this;
      let sortList = [];
      let defaultList = [..._this.defaultProductList];

      if(_this.listSortType == "PRICELOW"){
        sortList = defaultList.sort((a, b) => a.pd_amt1 - b.pd_amt1);

      }else if(_this.listSortType == "PRICEHIGH"){
        sortList = defaultList.sort((a, b) => b.pd_amt1 - a.pd_amt1);

      }else if(_this.listSortType == "SVLOW"){
        sortList = defaultList.sort((a, b) => a.pv1 - b.pv1);

      }else if(_this.listSortType == "SVHIGH"){
        sortList = defaultList.sort((a, b) => b.pv1 - a.pv1);

      }else{
        sortList = [..._this.defaultProductList];
      }
      _this.productList = [...sortList];
    },

    remove15perDate(){
      let _this = this;

      _this.apiRemove15perDate().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          if(res.data.result){
            _this.isRemove15per = res.data.isRemove15per;
          }
          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
            .then(res => {});
        }
      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    removeAroOnlyCategoryDate(){
      let _this = this;

      _this.apiRemoveAroOnlyCategoryDate().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          if(res.data.result){
            _this.isAroOnlyCategory = res.data.isAroOnlyCategory;
          }
          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
            .then(res => {});
        }
      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },
  }
};
</script>
<style>
a.rew19_btnPre, a.rew19_btnNext, a.rew19_basket_oder, a.rew19_aProduct{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/product/listAroOnly.vue